var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReputationCommentsBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "prefix__Layer",
    width: 18.817,
    height: 16.412,
    viewBox: "0 0 18.817 16.412",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "prefix__Vrstva_148",
    "data-name": "Vrstva 148"
  }, /*#__PURE__*/React.createElement("path", {
    id: "prefix__Trazado_155",
    fill: "#3f66b3",
    d: "M17.251 6.667h-2.566V4.956a2.566 2.566 0 0 0-2.566-2.566H3.566A2.566 2.566 0 0 0 1 4.956v5.132a2.566 2.566 0 0 0 2.566 2.566h1.326l1.24 1.377v.308A2.566 2.566 0 0 0 8.7 16.9h3.036l1.292 1.463a1.283 1.283 0 0 0 1.924 0l1.29-1.463h1.009a2.566 2.566 0 0 0 2.566-2.566V9.207a2.566 2.566 0 0 0-2.566-2.54zM3.566 10.943a.855.855 0 0 1-.855-.855V4.956a.855.855 0 0 1 .855-.856h8.553a.855.855 0 0 1 .855.855v5.132a.855.855 0 0 1-.855.855H8.638L7.15 12.654l-1.488-1.711zm14.541 3.421a.855.855 0 0 1-.855.855h-1.771L13.993 17 12.5 15.22H8.7a.855.855 0 0 1-.855-.855 1.351 1.351 0 0 0 .265-.231l1.29-1.463h2.72a2.566 2.566 0 0 0 2.566-2.566V8.394h2.566a.855.855 0 0 1 .855.855z",
    "data-name": "Trazado 155",
    transform: "translate(-1 -2.39)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReputationCommentsBlue);
export default __webpack_public_path__ + "static/media/reputation-comments-blue.97b775a333802e81d9c044f67c757e2c.svg";
export { ForwardRef as ReactComponent };